<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-invoice-view />

    <core-footer />

  </v-app>
</template>

<script>

export default {
  name: 'ViewInvoice',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewInvoiceView: () => import('../components/core/ViewInvoiceView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
